/** SA-1092 §3.7: the queue's words. */
export const QUEUE_EMPTY = 'Nothing waiting for a decision'
export const QUEUE_NEW = (n: number) => `${n} new`
export const QUEUE_LOAD_MORE = 'Load more'

/** A wait, hand-formatted: "just now" under a minute (or a future or
 * unreadable stamp), then minutes, hours, days and weeks, each floored. */
export function waitText(waitingSince: string, now: Date): string {
  const at = Date.parse(waitingSince)
  if (Number.isNaN(at)) return 'just now'
  const seconds = Math.floor((now.getTime() - at) / 1000)
  if (seconds < 60) return 'just now'
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes} min`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours} h`
  const days = Math.floor(hours / 24)
  if (days < 7) return `${days} d`
  return `${Math.floor(days / 7)} wk`
}
